/* SeeGart action analytics v1. Local image content never enters this adapter. */
(() => {
  'use strict';
  if (window.SeeGartTracking) return;
  const ID = 'G-1BTKWPBM5F', VERSION = '2026-10-12.1';
  const isRoom = /\/pages\/room-preview\/?$/.test(location.pathname);
  const isLanding = /\/pages\/custom-wall-art\/?$/.test(location.pathname);
  const testValue = new URLSearchParams(location.search).get('sg_qa') || '';
  const qa = /^qa[0-9a-z_-]{1,36}$/.test(testValue) ? testValue : '';
  const names = new Set(['sg_custom_landing_view','sg_room_preview_click','sg_room_preview_enter','sg_artwork_upload','sg_room_upload','sg_size_change','sg_design_save','sg_whatsapp_click']);
  const values = {
    preview_mode: ['store','upload'], room_source: ['preset','customer_photo'],
    save_type: ['design_details','preview_image'],
    entry_point: ['room_studio','custom_hero','custom_body','custom_page','product','home','navigation','other'],
    frame_option: ['Rolled Canvas','Frameless','Stretch+Gold Frame','Stretch+Silver Frame','Stretch+Black Frame','Stretch+White Frame','Stretch+Wood Frame','Stretch+Coffee Frame']
  };
  let roomInitialized = false, entrySent = false, landingSent = false, started = false, loaderFailed = false;
  let poll, lastPermit;
  function allowed() {
    try {
      const p = window.Shopify?.customerPrivacy;
      if (!p || typeof p.analyticsProcessingAllowed !== 'function') return false;
      const consent = p.currentVisitorConsent?.() || {};
      // The standalone API defaults permissively when all server context is absent.
      // Require actual region context or an explicit analytics choice first.
      if (!p.getRegion?.() && !['yes','no'].includes(consent.analytics)) return false;
      return p.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }
  function safeLocation() {
    const u = new URL(location.href), out = new URL(u.pathname, u.origin);
    for (const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']) {
      const v = u.searchParams.get(key);
      if (v && v.length <= 150 && /^[\w .+\-:/|]+$/.test(v) && !/@/.test(v)) out.searchParams.set(key,v);
    }
    if (isRoom) out.searchParams.set('mode', u.searchParams.get('mode') === 'upload' ? 'upload' : 'store');
    return out.href;
  }
  function safeReferrer() {
    try { const u = new URL(document.referrer); return u.origin + u.pathname; } catch (_) { return ''; }
  }
  function tag() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); }
  function start() {
    if (!allowed() || loaderFailed) return false;
    if (started) return true;
    if (isRoom) {
      // This standalone page does not include the normal theme's Google app tag.
      // Only its existing GA4 destination is configured; no automatic page_view.
      window['ga-disable-' + ID] = false;
      tag('consent', 'default', {analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
      tag('js', new Date());
      tag('config', ID, {send_page_view:false, allow_google_signals:false, allow_ad_personalization_signals:false, page_location:safeLocation(), page_referrer:safeReferrer()});
      const script = document.createElement('script');
      script.async = true; script.src = 'https://www.googletagmanager.com/gtag/js?id=' + ID;
      script.onerror = () => { loaderFailed = true; };
      document.head.appendChild(script);
    } else {
      // Google & YouTube owns initialization on ordinary storefront pages.
      // Do not configure a second page tag or duplicate its commerce/page events.
      if (!Array.from(document.scripts).some(s => /https:\/\/www\.googletagmanager\.com\/gtag\/js/.test(s.src))) return false;
    }
    started = true; return true;
  }
  function track(name, input = {}) {
    if (!names.has(name)) return false;
    if (name === 'sg_room_preview_enter') {
      roomInitialized = true;
      if (entrySent) return false;
    }
    if (!start() || !allowed()) return false;
    const params = {send_to:ID, tracking_version:VERSION, sg_environment:qa ? 'test' : 'customer', page_location:safeLocation(), page_referrer:safeReferrer(), transport_type:'beacon'};
    for (const key of Object.keys(values)) if (values[key].includes(input[key])) params[key] = input[key];
    for (const key of ['size_width_cm','size_height_cm']) if (Number.isFinite(input[key]) && input[key] > 0 && input[key] <= 1000) params[key] = Math.round(input[key]*10)/10;
    if (qa) { params.debug_mode = true; params.qa_run = qa; }
    tag('event', qa ? name.replace(/^sg_/, 'qa_') : name, params);
    if (qa) console.info('[SeeGart QA] queued ' + name.replace(/^sg_/, 'qa_'));
    if (name === 'sg_room_preview_enter') entrySent = true;
    return true;
  }
  window.SeeGartTracking = Object.freeze({track:(...args) => { try { return track(...args); } catch (_) { return false; } }});
  function ready() {
    const permit = allowed();
    if (qa && permit !== lastPermit) console.info('[SeeGart QA] analytics permission ' + permit);
    lastPermit = permit;
    if (isRoom && started) {
      window['ga-disable-' + ID] = !permit;
      tag('consent', 'update', {analytics_storage:permit ? 'granted' : 'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    }
    if (!permit) return;
    if (isLanding && !landingSent) landingSent = track('sg_custom_landing_view', {entry_point:'custom_page'});
    if (isRoom && roomInitialized && !entrySent) track('sg_room_preview_enter', {preview_mode:new URLSearchParams(location.search).get('mode') === 'upload' ? 'upload' : 'store',entry_point:'room_studio'});
  }
  // Only a current page entry is observed when consent becomes available;
  // uploads/clicks performed without analytics consent are not replayed.
  document.addEventListener('visitorConsentCollected', ready);
  if (!window.Shopify?.customerPrivacy) {
    const privacy = document.createElement('script');
    privacy.src = 'https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js';
    privacy.onload = ready;
    document.head.appendChild(privacy);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let u; try { u = new URL(link.href, location.href); } catch (_) { return; }
    if (u.origin !== location.origin || !/\/pages\/room-preview\/?$/.test(u.pathname)) return;
    if (qa) { u.searchParams.set('sg_qa',qa); link.href = u.href; }
    const entry = isLanding ? (link.closest('header,nav') ? 'navigation' : 'custom_page') : location.pathname.includes('/products/') ? 'product' : location.pathname === '/' ? 'home' : link.closest('header,nav') ? 'navigation' : 'other';
    track('sg_room_preview_click', {entry_point:entry,preview_mode:u.searchParams.get('mode') === 'upload' ? 'upload' : 'store'});
  });
  let attempts = 0;
  poll = setInterval(() => { ready(); if (++attempts >= 40 || (isRoom ? entrySent : isLanding ? landingSent : started)) clearInterval(poll); }, 250);
  window.addEventListener('pagehide', () => clearInterval(poll), {once:true});
  ready();
})();
